import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

import { DataChannelClientAppVersionMessage } from '../../video-sdk';
import { inSessionPatientInformationAtom } from '../state';

export function useHandleClientAppVersionCallback() {
  const setInSessionPatientInformation = useSetAtom(inSessionPatientInformationAtom);

  return useCallback(
    (message: DataChannelClientAppVersionMessage) => {
      const visitorId = message.sender.entityId;
      // Emits when visitor is already in session
      setInSessionPatientInformation((prev) => {
        if (!prev || prev.visitorUuid !== visitorId) return prev;

        return {
          ...prev,
          appVersion: message.appVersion,
        };
      });
    },
    [setInSessionPatientInformation],
  );
}
